import { render, staticRenderFns } from "./AttendanceSettings.vue?vue&type=template&id=29a2b397&scoped=true&"
import script from "./AttendanceSettings.vue?vue&type=script&lang=js&"
export * from "./AttendanceSettings.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceSettings.vue?vue&type=style&index=0&id=29a2b397&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2b397",
  null
  
)

export default component.exports